import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { graphql } from "@apollo/client/react/hoc"
import TabbedListingPage from "../Material/TabbedListingPage"
import { HasPermissionsQuery } from "../Functions/querys"
import TenantListContainer from "./TenantManagement/TenantListContainer"
import BranchListContainer from "./BranchMangement/BranchListContainer"
import MembersListContainer from "./MembersManagement/MembersListContainer"
import PermissionsListContainer from "./PermissionsManagement/PermissionsListContainer"
import GroupsListContainer from "./GroupsManagement/GroupsListContainer"
import FinancialAccountListContainer from "./FinancialAccount/FinancialAccountListContainer"
import ObjectPermissionsListContainer from "./ObjectPermissionManagement/ObjectPermissionsListContainer"
import { ROUTES } from "../Layout/routes"

// Most of these panels only read currentUser (Members/FinancialAccount self-supply
// everything else -- location/navigate, advanced filters -- via their own hooks and
// HOC wraps). Branches is the exception: BranchListContainer isn't wrapped with
// withApolloClient, so it needs location/navigate passed in explicitly. Permissions,
// Groups and Object Permissions read no props at all -- their own RestrictedSection
// does its own permission check independently of what's passed here.
const organizationTabs = [
    { id: "tenants", name: "Tenants", iconClassName: "fa fa-sitemap", permissionRequired: "view_tenant", render: ({ currentUser }) => <TenantListContainer currentUser={currentUser} /> },
    { id: "branches", name: "Branches", iconClassName: "fa fa-code-fork", permissionRequired: "view_branch", render: ({ currentUser, location, navigate }) => <BranchListContainer currentUser={currentUser} location={location} navigate={navigate} /> },
    { id: "members", name: "Members", iconClassName: "fa fa-users", permissionRequired: "view_member", render: ({ currentUser }) => <MembersListContainer currentUser={currentUser} /> },
    { id: "permissions", name: "Permissions", iconClassName: "fa fa-eye-slash", permissionRequired: "view_permission", render: () => <PermissionsListContainer /> },
    { id: "groups", name: "Groups", iconClassName: "fa fa-universal-access", permissionRequired: "view_group", render: () => <GroupsListContainer /> },
    { id: "billing_management", name: "Billing Management", iconClassName: "fa fa-sliders", permissionRequired: "view_financialaccount", render: ({ currentUser }) => <FinancialAccountListContainer currentUser={currentUser} /> },
    { id: "object_permissions", name: "Object Permissions", iconClassName: "fa fa-key", permissionRequired: "view_groupobjectpermission", render: () => <ObjectPermissionsListContainer /> },
]

const OrganizationPage = (props) => {
    const location = useLocation()
    const navigate = useNavigate()

    return (
        <TabbedListingPage
            className="organizationPage"
            route={ROUTES.organization}
            tabs={organizationTabs.map(tab => ({ ...tab, render: () => tab.render({ currentUser: props.currentUser, location, navigate }) }))}
            hasPermissions={props.hasPermissions}
            loading={props.loading}
        />
    )
}

export { organizationTabs }

export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: {
            userPermissions: [
                "view_tenant", "view_branch", "view_member", "view_permission",
                "view_group", "view_financialaccount", "view_groupobjectpermission",
            ],
        },
    }),
    props: ({ data: { hasPermissions, loading } }) => ({ hasPermissions, loading }),
})(OrganizationPage)
